export const searchResultsTab = Object.freeze({
    AllResults: 5,
    AudioVisual: 0,
    Books: 1,
    Serials: 2,
    VisualArts: 3,
    WebsitesAndBlogs: 6, //Not used 
    Contacts: 4
});